export default "__VITE_ASSET__Egmjf5EI__"